import { useState } from "react";
import { RoleRightsForModule } from "../../utils/utils";
import RoleManagementListing from "./RoleManagementListing";

const RoleHeader = ({
  setSubCategory,
  subCategory,
  setRoleEditID,
  setRoleName,
}) => {
  const [searchValue, setSearchValue] = useState("");
  // role header render
  return (
    <>
      <div className="row align-items-center py-3">
        <div className="col-12 col-md-6 col-xl-6">
          <h5 className="intro-title">Role Management</h5>
        </div>
        <div className="col-12 col-md-6 col-xl-6 mt-3 mt-md-0 text-start text-md-end">
          <div className="user-right-filter-grup">
            <div className="user-search-div me-2">
              <div className="intro-searchbar">
                <button type="submit" className="filter-search-btn"></button>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  name="role_search"
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                  }}
                />
                {searchValue.length > 0 && (
                  <button
                    type="button"
                    class="btn search-reset-btn"
                    onClick={() => setSearchValue("")}
                  >
                    <svg
                      class="close-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="13.414"
                      height="13.414"
                      viewBox="0 0 13.414 13.414"
                    >
                      <g
                        id="Group_31758"
                        data-name="Group 31758"
                        transform="translate(0.707 0.707)"
                      >
                        <path
                          id="Path_48155"
                          data-name="Path 48155"
                          d="M0,0,12,12"
                          fill="none"
                          stroke="#313b5c"
                          stroke-width="2"
                        ></path>
                        <path
                          id="Path_48154"
                          data-name="Path 48154"
                          d="M12,0,0,12"
                          fill="none"
                          stroke="#313b5c"
                          stroke-width="2"
                        ></path>
                      </g>
                    </svg>
                  </button>
                )}
              </div>
            </div>
            {RoleRightsForModule("Add", "Roles") && (
              <button
                className="btn btn-primary-md btn-lg"
                onClick={() => {
                  setSubCategory("add_role");
                }}
              >
                + Add Role
              </button>
            )}
          </div>
        </div>
      </div>
      {/* role management table listing component */}
      <RoleManagementListing
        setSubCategory={setSubCategory}
        subCategory={subCategory}
        setRoleEditID={setRoleEditID}
        searchValue={searchValue}
        setRoleName={setRoleName}
      />
    </>
  );
};

export default RoleHeader;
